<section class="grid-container">
    <div class="grid-x">
        <div class="medium-4">
            <ul class="no-bullet">
                <li>
                    <h2 class="h4 no-margin-bottom">Wells</h2>
                    <p class="h1 bold dark-orange">{{wellCount}}</p>
                </li>
                <li>
                    <h2 class="h4 no-margin-bottom">Pending Permits</h2>
                    <p class="h1 bold light-green">{{pendingPermitsCount}}</p>
                </li>
                <!--<li>
                    <h2 class="h4 no-margin-bottom">Permits Approved</h2>
                    <p class="h1 bold light-blue">{{approvedPermitsCount}}</p>
                </li>-->
                <li>
                    <button class="button" (click)="routeToWellViewer()" aria-label="Go to ODNR Full Well Map"> Go to ODNR Full Well Map</button>
                </li>

                
            </ul>
        </div>
        <div class="medium-8">
            <div class="mapContainerNode">
                <div id="mapViewNode" #mapViewNode></div>
            </div>
        </div>
    </div>
</section>